/**
 * CONFIGURACIÓN DE BADGES DE DESCUENTO
 * Shopify Badge System - StudioJohan
 * 
 * Edita este archivo para configurar tus badges de descuento
 */

const BADGE_CONFIG = {
  // ====== CONFIGURACIÓN GENERAL ======
  enabled: true, // true = activar badges, false = desactivar
  
  // ====== DESCUENTO GENERAL (25% en toda la tienda) ======
  storeWideDiscount: {
    enabled: true,
    percentage: 25,
    text: "25% OFF", // Puedes cambiar el texto
    backgroundColor: "#FF0000", // Color rojo
    textColor: "#FFFFFF" // Color blanco
  },
  
  // ====== DESCUENTO PARA PRODUCTOS SELECCIONADOS (30%) ======
  selectedProductsDiscount: {
    enabled: true,
    percentage: 30,
    text: "30% OFF",
    backgroundColor: "#FF0000",
    textColor: "#FFFFFF"
  },
  
  // ====== MÉTODOS PARA SELECCIONAR PRODUCTOS DEL 30% ======
  // Puedes usar uno o varios métodos a la vez
  
  selectionMethod: {
    // MÉTODO 1: Por IDs de producto de Shopify
    // Encuentra el ID en: Admin > Productos > [producto] > URL tiene el número
    byProductIds: {
      enabled: false,
      ids: [
        "1234567890", // Reemplaza con tus IDs reales
        "9876543210",
        "5555555555"
      ]
    },
    
    // MÉTODO 2: Por Handle de producto (URL del producto)
    // Ejemplo: si la URL es /products/vestido-azul, el handle es "vestido-azul"
    byProductHandles: {
      enabled: true,
      handles: [
        "cropped-puffer-vest",
        "pilates-mini-jumpsuit",
        "golfy-mini-dress",
        "halter-flare-jumpsuit"
      ]
    },
    
    // MÉTODO 3: Por Colecciones
    // Todos los productos de estas colecciones tendrán 30% OFF
    byCollections: {
      enabled: false,
      handles: [
        "liquidacion",
        "ofertas-especiales",
        "fin-de-temporada"
      ]
    },
    
    // MÉTODO 4: Por Tags de producto
    // Agrega estos tags en Shopify Admin a los productos que quieras
    byTags: {
      enabled: false,
      tags: [
        "descuento-30",
        "super-oferta",
        "promocion-especial"
      ]
    },
    
    // MÉTODO 5: Por Vendor (Proveedor)
    byVendor: {
      enabled: false,
      vendors: [
        "Mi Marca",
        "Proveedor XYZ"
      ]
    }
  },
  
  // ====== POSICIÓN Y ESTILO DEL BADGE ======
  badgeStyle: {
    position: "top-right", // Opciones: "top-left", "top-right", "bottom-left", "bottom-right"
    offsetX: 10, // Distancia desde el borde horizontal (píxeles)
    offsetY: 10, // Distancia desde el borde vertical (píxeles)
    fontSize: "14px",
    fontWeight: "bold",
    padding: "6px 12px",
    borderRadius: "3px",
    zIndex: 999,
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    // Animación opcional
    animation: {
      enabled: false, // true para activar animación de pulso
      duration: "2s"
    }
  },
  
  // ====== PÁGINAS DONDE MOSTRAR LOS BADGES ======
  showOn: {
    collectionPages: true, // Páginas de colecciones
    productPages: true,    // Páginas de producto individual
    homePage: true,        // Página de inicio
    searchPages: true,     // Resultados de búsqueda
    cartPage: false        // Carrito (generalmente no se usa)
  },
  
  // ====== SELECTORES CSS (AVANZADO) ======
  // Modifica solo si tu theme usa clases diferentes
  selectors: {
    productCard: [
      '.product__media-item',
      '.card-wrapper',
      '.product-card',
      '.product-item',
      '.grid-product',
      '.product-grid-item',
      '[data-product-id]',
      '[data-media-id]'
    ],
    productImage: [
      '.product-media-container',
      '.product__media',
      '.modal-opener',
      '.product__modal-opener',
      '.card__media',
      '.media',
      '.product-card__image',
      '.product-item__image',
      '.grid-product__image-wrapper',
      '.product__media-wrapper',
      '.product-image-wrapper'
    ]
  },
  
  // ====== MODO DEBUG ======
  debug: true // true para ver mensajes en consola del navegador
};

// No editar - Exportar configuración
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BADGE_CONFIG;
}
